/**
 * Supported languages.
 *
 * Adding a language is ONE entry here — the `lang` column, the primary key
 * (name, lang), the API, and the editor's language dropdown all read from this list.
 * Nothing else changes.
 *
 * Codes are BCP 47 language tags — what `<html lang>`, the `Accept-Language` header
 * and the native `Intl` API already speak. Custom codes (ENG/RUS/LAT) would mean
 * maintaining a mapping table forever, and `LAT` is ambiguous besides: Latvian (lv)
 * or Latin (la)?
 */
export enum Lang {
  EN = 'en',
  // RU = 'ru',
  // LV = 'lv',
  // DE = 'de',
}

export const DEFAULT_LANG = Lang.EN;

export const LANG_LABELS: Record<string, string> = {
  en: 'English',
  ru: 'Русский',
  lv: 'Latviešu',
  de: 'Deutsch',
};

export const ALL_LANGS: readonly Lang[] = Object.values(Lang);

export const isLang = (v: unknown): v is Lang => ALL_LANGS.includes(v as Lang);

export const toLang = (v: unknown): Lang => (isLang(v) ? v : DEFAULT_LANG);

export const langLabel = (code: string): string => LANG_LABELS[code] ?? code;
